import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { translate } from 'filters';

const FilterContextMenu = ({ options, onClick }) => {
  const onClickOverlay = (e) => {
    e.preventDefault();

    if (e.target.classList.contains('home-filter-context-menu')) {
      onClick(-1);
    }
  };

  const action = (item) => {
    onClick(item);
  };

  return (
    <div
      className={`home-filter-context-menu ${
        options.show ? '' : 'display-none'
      }`}
      onClick={onClickOverlay}
      onContextMenu={onClickOverlay}
    >
      <ul
        style={{
          left: `${options.x}px`,
          top: `${options.y}px`,
        }}
      >
        {(options.items || []).length > 0
          ? options.items.map((item, idx) => (
              <li
                key={idx}
                onClick={() => action(item)}
                className={`flex-row items-center flex-between ${item.customStyle}`}
              >
                <span className="flex-fill m-r-4">{translate(item.title)}</span>
                {item.prevOrderCheck && <i className="zmdi zmdi-check"></i>}
              </li>
            ))
          : null}
      </ul>
    </div>
  );
};

FilterContextMenu.propTypes = {
  options: PropTypes.object,
  onClick: PropTypes.func,
};

export default observer(FilterContextMenu);
